/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Pressureminsetpoint2Inputs */



/**
* | output |
* | --- |
* | "Minimum pressure setpoint" |
*
* @param {Ahu_History_Key_Pressureminsetpoint2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_pressureminsetpoint2 = /** @type {((inputs?: Ahu_History_Key_Pressureminsetpoint2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Pressureminsetpoint2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Minimum pressure setpoint")
	return /** @type {LocalizedString} */ ("Consigne minimum de pression")
});
export { ahu_history_key_pressureminsetpoint2 as "ahu_history_key_pressureMinSetpoint" }